import classNames from 'classnames';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import LevelListItemTag from '../components/LevelListItemTag';
import { Button } from './Button';
import { Icon } from './Icon';
import { UnitList } from './UnitList';
import { UnitListItemProps } from './UnitListItem';

export type LevelListItemStatus = 'done' | 'current' | 'blocked';
export interface LevelListItemProps {
  status: LevelListItemStatus;
  title: string;
  buttonHref?: string;
  expanded?: boolean;
  unitListItems?: UnitListItemProps[];
}

const LevelListItem: React.FC<LevelListItemProps> = (props) => {
  const [expanded, setExpanded] = useState<boolean>(props.expanded || false);
  const __ = useTranslation().t;
  const ContinueButton = () => {
    if (props.status !== 'current') {
      return null;
    }
    return (
      <>
        <div className="d-none d-md-inline-block">
          <Button label={__('continue')} href={props.buttonHref} />
        </div>
        <div className="d-inline-block d-md-none">
          <Button label={__('continue')} href={props.buttonHref} size="sm" />
        </div>
      </>
    );
  };

  const handleToggle = () => setExpanded(!expanded);

  const ExpandedLessonList = () => {
    if (!expanded) {
      return null;
    }
    return <UnitList units={props.unitListItems || []} />;
  };

  const ExpandedHeader = () => {
    if (!expanded) {
      return null;
    }
    return <div className="oejr-lesson-list-header" />;
  };

  return (
    <div
      className={classNames(
        'oejr-level-list-item-wrapper',
        expanded && 'oejr-level-list-item-wrapper-expanded',
      )}
    >
      <ExpandedHeader />
      <div
        onClick={handleToggle}
        className={classNames(
          'oejr-level-list-item',
          `oejr-level-list-item-${props.status}`,
          expanded && 'oejr-level-list-item-expanded',
        )}
      >
        <h1>{props.title}</h1>
        <div className="oejr-level-list-item-controls">
          <ContinueButton />
          <Icon name={expanded ? 'chevron-up' : 'chevron-down'} />
        </div>
        <LevelListItemTag status={props.status} />
      </div>
      <ExpandedLessonList />
    </div>
  );
};

export default LevelListItem;
